var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 3.33334C1.6665 2.41286 2.4127 1.66667 3.33317 1.66667H11.6665C12.587 1.66667 13.3332 2.41286 13.3332 3.33334V6.66667H16.6665C17.587 6.66667 18.3332 7.41286 18.3332 8.33334V16.6667C18.3332 17.5872 17.587 18.3333 16.6665 18.3333H8.33317C7.4127 18.3333 6.6665 17.5872 6.6665 16.6667V13.3333H3.33317C2.4127 13.3333 1.6665 12.5872 1.6665 11.6667V3.33334ZM8.33317 13.3333V16.6667H16.6665V8.33334H13.3332V11.6667C13.3332 12.5872 12.587 13.3333 11.6665 13.3333H8.33317ZM11.6665 11.6667V3.33334H3.33317V11.6667H11.6665Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.43fb5246047bc283a8904d0c51882973.svg";
export { ForwardRef as ReactComponent };